import { ElementType, PropsWithChildren } from "react";

import { cn } from "@/utils/cn";

interface CardProps extends PropsWithChildren {
  className?: string;
  as?: ElementType;
}

function Card({ className, children, as: Component = "div", ...props }: CardProps) {
  return (
    <Component
      className={cn("flex flex-col gap-2 overflow-hidden rounded-xl border border-lightgray bg-white", className)}
      {...props}
    >
      {children}
    </Component>
  );
}

export default Card;
